import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import { isEmpty } from '../../../Common/Common';
import Select from '../../../Part_Sample/Select';
import Display_Actions from '../../../Display_Actions/Display_Actions';

import edit_icon from '../../../../Images/Daikin_Images/image/Edit.png';

export default class Schedule_Step3_Pattern extends Component {
	constructor(props) {
		super(props);
		let selected_pattern_id = '';
		// kaiwei 20210506 Changed Dropdown to Select
		//let drop_down_list = [];

		// Program
		this.program = {};
		if (this.props.param.program != null) {
			this.program = JSON.parse(JSON.stringify(this.props.param.program));
		}

		// Selected Pattern Id
		if (this.props.param.pattern_id != null && this.props.param.pattern_id != '') {
			selected_pattern_id = this.props.param.pattern_id;
			this.original_pattern_id = this.props.param.pattern_id;
		}

		this.state = {
			selected_pattern_id: selected_pattern_id,
		}
	}

	handlePrevious = () => {
		let param = this.props.param;
		param.pattern_id = this.state.selected_pattern_id;
		param.program = this.program;
		if (param.from == 'Schedule_Office_Summary') {
			let from = param.from;
			if (this.props.param.program_id != null) {
				param.from = 'Schedule';
			} else {
				delete param.from;
			}
			this.props.content_handler(from, param);
		} else if (param.original_from == 'Schedule_Office_Summary') {
			let from = param.from;
			if (this.props.param.program_id != null) {
				param.from = 'Schedule';
			} else {
				delete param.from;
				delete param.original_from;
			}
			this.props.content_handler('Schedule_Office_Summary', param);
		} else if (param.from != null) {
			let from = param.from;
			delete param.from;
			this.props.content_handler(from, param);
		} else {
			this.props.content_handler('Schedule_Step2_Target', param);
		}
	}

	handleChangePatternID = (val) => {
		this.setState({ selected_pattern_id: val })
	}

	handleAddPattern = () => {
		let param = this.props.param;
		param.pattern_id = '';
		param.program = this.program;
		if (this.state.selected_pattern_id != '') param.selected_pattern_id = this.state.selected_pattern_id;
		if (param.from == 'Schedule_Office_Summary') param.original_from = 'Schedule_Office_Summary';
		this.props.content_handler('Add_Edit_Pattern', param);
	}

	handleEditPattern = () => {
		let param = this.props.param;
		let pattern_id = '';
		if (this.state.selected_pattern_id != '') pattern_id = this.state.selected_pattern_id;
		param.pattern_id = pattern_id;
		param.program = this.program;
		if (param.from == 'Schedule_Office_Summary') param.original_from = 'Schedule_Office_Summary';
		this.props.content_handler('Add_Edit_Pattern', param);
	}

	handleRegister = () => {
		if (this.state.selected_pattern_id == '' || this.state.selected_pattern_id == null || this.state.selected_pattern_id == this.props.receiver.getString('select_a_routine')) {
			window.app.showToast(this.props.receiver.getString('no_routine'), 3000);
			return;
		}

		let param = this.props.param;
		param.program = this.program;

		if (param.original_pattern_id == null && param.original_pattern_id == undefined) {
			// First time selecting a pattern
			param.original_pattern_id = '';
		} else if (param.original_pattern_id != '') {
			// Already has an original pattern id i.e. modifying a routine (after come back from step 4)
			// Do nothing
		} else if (param.pattern_id != this.state.selected_pattern_id) {
			// Modifying a routine for first time
			param.original_pattern_id = param.pattern_id;
		}
		param.pattern_id = this.state.selected_pattern_id;
		if (param.from == 'Schedule_Office_Summary') param.original_from = 'Schedule_Office_Summary';
		this.props.content_handler('Schedule_Step4_Execute_Days', param);
	}

	handleDelete = () => {
		delete this.program.action[this.props.param.pattern_id];
		let param = this.props.param;
		param.program = this.program;
		param.pattern_id = '';
		param.op_type = 'pattern';
		param.from = 'Schedule';
		this.props.content_handler('Schedule_Office_Summary', param);
	}

	render() {
		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		let dropdown_left_margin = 80;
		//let selected_pattern_name = this.props.receiver.getString('select_a_routine');
		let action = [];
		let pattern_options = [];

		if (this.state.selected_pattern_id != '') {
			//selected_pattern_name = this.props.param.schedule.pattern[this.state.selected_pattern_id].name;
			action = this.props.param.schedule.pattern[this.state.selected_pattern_id].action;
			pattern_options.push(<option value={''} disabled={true} key={''}>{this.props.receiver.getString('select_a_routine')}</option>);
		} else {
			pattern_options.push(<option value={''} selected={true} disabled={true} key={''}>{this.props.receiver.getString('select_a_routine')}</option>);
		}

		let existing_patterns = [];

		if (!isEmpty(this.props.param.program.action)) existing_patterns = Object.keys(this.props.param.program.action)

		if (!isEmpty(this.props.param.schedule)) {
			if (!isEmpty(this.props.param.schedule.pattern)) {
				for (let pattern_id in this.props.param.schedule.pattern) {
					if (!existing_patterns.includes(pattern_id) || pattern_id == this.props.param.pattern_id || pattern_id == this.props.param.original_pattern_id) {
						pattern_options.push(<option value={pattern_id} key={pattern_id}>{this.props.param.schedule.pattern[pattern_id].name}</option>);
					}
				}
			}
		}

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('sel_routine')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={'add'}
						handleRightButton={this.handleAddPattern}
					/>
					<div style={{ height: this.props.height - 150, overflow: 'auto' }}>
						<div style={{ marginLeft: 20, textAlign: 'left', marginBottom: 20 }}>
							<span className='title' style={{ fontSize: 20 }}>{this.props.receiver.getString('schedule_step3_instr')}</span>
						</div>
						<div style={{ textAlign: 'left', marginLeft: 20, marginTop: 20, marginBottom: 20 }}>
							<div style={{ display: 'inline-block', width: this.props.width - 70, }}>
								<Select
									options={pattern_options}
									value={this.state.selected_pattern_id}
									onSelect={this.handleChangePatternID}
								/>
							</div>
							<div style={{ display: this.state.selected_pattern_id != '' ? 'inline-block' : 'none', width: 30, height: 30, verticalAlign: 'bottom' }}>
								<img src={edit_icon} style={{ cursor: 'pointer', width: 30, height: 30 }} onClick={this.handleEditPattern} />
							</div>
						</div>
						<div style={{ width: this.props.width - 40, marginLeft: 'auto', marginRight: 'auto', textAlign: 'center', border: '1px solid black', paddingBottom: action.length == 0 ? 0 : 10 }}>
							<div style={{ paddingTop: 10, textAlign: 'left', paddingLeft: 10, paddingBottom: 10, fontWeight: 500, background: "#f1f1f1" }}>
								<span>{this.props.receiver.getString('actions')}</span>
							</div>
							{Object.keys(action).sort().map((time) => {
								let action_details = action[time];
								return (
									<div style={{ textAlign: 'left', marginTop: 20, marginBottom: 50 }}>
										<div style={{ display: 'inline-block', width: this.props.width / 2 - 40, textAlign: 'left', verticalAlign: 'top', marginLeft: 20 }}>
											<span> {time} </span>
										</div>
										<Display_Actions style={{ display: 'inline-block', width: this.props.width / 2 - 40, textAlign: 'right' }} point_info={null} actions={action_details} receiver={this.props.receiver} />
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}